import React from "react";
import { Button } from "antd";
import { Link } from "react-router-dom";

const bookNowStatus = (props) => {
  return (
    <section className="Book-now">
      <div className="book-now-wrap">
        <div className="amount-per-day">
          <span>{props.price}</span>/ Day
        </div>
        <div>
          <Link to="/carbookingcheckout">
          <Button className="book-now-btn">Book Now</Button></Link>
        </div>
      </div>
    </section>
  );
};

export default bookNowStatus;
